import { render, staticRenderFns } from "./DonutConsultationsMDTByPathologiesSoinTravailChart.vue?vue&type=template&id=1ee1d4aa&"
import script from "./DonutConsultationsMDTByPathologiesSoinTravailChart.vue?vue&type=script&lang=ts&"
export * from "./DonutConsultationsMDTByPathologiesSoinTravailChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports